/**
 * Alert tones — the presets a team can choose from, plus a small resolver.
 * ─────────────────────────────────────────────────────────────────────────────
 * Preset audio files live in `frontend/public/tones/` and are served at
 * `/tones/<id>.mp3`. The chosen tone is stored per-country in NotificationSettings
 * (`sound.tone` = a preset id, or "custom" with `sound.customTone.url`). Both the
 * tone picker (Notifications Center) and the alert engine (useOrderAlerts) resolve
 * a tone the same way through here.
 */

export const TONES = [
  { id: "classic", name: "Classic", url: "/tones/classic.mp3", desc: "The original Lusuku order chime." },
  { id: "chime", name: "Chime", url: "/tones/chime.mp3", desc: "Soft two-note chime." },
  { id: "ding", name: "Ding", url: "/tones/ding.mp3", desc: "Short, bright ding." },
  { id: "marimba", name: "Marimba", url: "/tones/marimba.mp3", desc: "Warm marimba arpeggio." },
  { id: "alert", name: "Alert", url: "/tones/alert.mp3", desc: "Urgent double beep." },
];

export const DEFAULT_TONE_ID = "classic";

/**
 * Resolve a playable URL for a tone selection.
 * @param {string} tone       preset id or "custom"
 * @param {string} customUrl  uploaded tone URL (when tone === "custom")
 * @param {string} fallback   URL to use if nothing resolves (e.g. bundled default)
 * @returns {string}
 */
export function resolveToneUrl(tone, customUrl, fallback) {
  if (tone === "custom") return customUrl || fallback || TONES[0].url;
  const t = TONES.find((x) => x.id === tone);
  return (t && t.url) || fallback || TONES[0].url;
}
